/**
 * Tela aberta em modo slim (`?slim=1`): sem menu principal, sem link de voltar —
 * só o conteúdo. Ver `lib/slim.ts`.
 */
import { useSearchParams } from 'react-router-dom';

import { PARAM_SLIM } from '@/lib/slim';

export function useModoSlim(): boolean {
  const [searchParams] = useSearchParams();
  return searchParams.get(PARAM_SLIM) === '1';
}
